import {
    Component,
    Input,
} from '@angular/core';
import { Product } from '../../../shared/interfaces/product';

@Component({
    selector: 'app-block-products-carousel',
    templateUrl: './block-products-carousel.component.html',
    styleUrls: ['./block-products-carousel.component.scss']
})
export class BlockProductsCarouselComponent {
    @Input() header: string;
    @Input() products: Product[] = [];
    constructor(
    ) { }
}
